<template>
  <div class="view">
    <Title title="観光ポイント"/>
    <TourismMain/>
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import TourismMain from '@/components/TourismMain'

export default {
  components: {
    Title,
    TourismMain
  },
  created: function () {
    this.$store.dispatch('tourism/retrieveTourisms')
  }
}
</script>
